module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/endereco-local-tipo/endereco-local-tipo.component.css
// module id = ./src/app/endereco-local-tipo/endereco-local-tipo.component.css
// module chunks = main